import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-50" data-id="element-39">
      {/* Mobile sidebar */}
      <div className={`${sidebarOpen ? 'block' : 'hidden'} fixed inset-0 z-40 lg:hidden`} data-id="element-40">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-41"></div>
        <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white" data-id="element-42">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-43">
            <button className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-44">
              <span className="sr-only" data-id="element-45">Close sidebar</span>
              <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-46">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-47" />
              </svg>
            </button>
          </div>
          <Sidebar mobile={true} data-id="element-48" />
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden lg:flex lg:flex-shrink-0" data-id="element-49">
        <div className="flex flex-col w-64" data-id="element-50">
          <div className="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white" data-id="element-51">
            <Sidebar data-id="element-52" />
          </div>
        </div>
      </div>
      {/* Main content */}
      <div className="flex flex-col w-0 flex-1 overflow-hidden" data-id="element-53">
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} data-id="element-54" />
        <main className="flex-1 relative overflow-y-auto focus:outline-none" data-id="element-55">
          <div className="py-6 px-4 sm:px-6 md:px-8" data-id="element-56">
            <Outlet data-id="element-57" />
          </div>
        </main>
      </div>
    </div>;
}